module.exports = __webpack_public_path__ + "img/京东云短信V3.10迭代（互动营销引导页面） – 无按钮.170ad341.png";